
import { useFormik } from "formik";
import {useMemo, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import useUserData from "../user/useUserData";
import {handleAxiosErrors} from "../../helpers/errorHandling";
import {enqueueSnackbar} from "notistack";
import {API} from "../../helpers/constants";
import {PAGE_LOGIN} from "../../locales/pages/namespaces";
import * as yup from "yup";

export const useSignUp = ({onClose}) => {
const [loading,setLoading] = useState(false)
    const {token} = useUserData()
    const { t } = useTranslation(PAGE_LOGIN)


    const onSubmit = (values) => {
     setLoading(true)
        axios({
            method: 'post',
            data: {
                email: values.email,
                password: values.password,
                name: values.name,
                company: values.company,
                country: values.country,
                phone: values.phone,
                afm: values.afm,
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            url: `${API}/en/register`
        }).then((res) => {
            enqueueSnackbar(t('User was successfully submitted!'), {
                variant: 'success',
                autoHideDuration: 3000,
            })
            onClose()
         setLoading(false)
        }).catch((error) => {
            setLoading(false)
            enqueueSnackbar(error.response.data.message, {
                variant: 'error',
                autoHideDuration: 3000,
            })

        })
    }
    const validationSchema = yup.object().shape({
        name: yup.string().required(t('Required')),
        // company: yup.string().required(t('Required')),
        country: yup.string().required(t('Required')),
        phone: yup.string().required(t('Required')).matches(/^[0-9]{9,10}$/, t('Invalid phone number')),
        email: yup.string().required(t('Required')).email(t('Invalid email')),
        afm: yup.string().required(t('Required')).matches(/^[0-9]{8,10}$/, t('Invalid AFM')),
        password: yup.string().required(t('Required')).matches(/^.{60}$|(^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])).{6,20}$)/,
            t('Password must be between 6-20 characters and contain at least 3 of the following. -Upper case character -Lower case character -Numeric digit -Special character')),
        confirmPassword: yup.string().required(t('Required')).oneOf([yup.ref('password'), null], t('Passwords must match')),
        terms: yup.boolean().oneOf([true], t('Required'))
    })

    const formik = useFormik({
        //enableReinitialize: true,
        initialValues:{
            name: "",
            company: "",
            country: "",
            phone: "",
            email: "",
            afm: "",
            password: "",
            confirmPassword: "",
            newsletterOptIn: false,
            promotionsOptIn: false,
            terms: false,
        },
        validationSchema: validationSchema,
        onSubmit: onSubmit
    });


    const countryOptions = [
        { value: "1", label: t("Greece") },
        { value: "31", label: t("Cyprus") },
    ];

    const activityOptions = [
        { value: "coffee", label: t("Cafeteria")},
        { value: "hotel", label: t("Hotel units") },
        { value: "office", label: t("Offices / Companies") },
    ];

    return {
        formik,
        loading,
        countryOptions,
        activityOptions,
    };
};
